import { render } from "./Plane.vue?vue&type=template&id=0196643e"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Plane.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0196643e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0196643e', __exports__)) {
    api.reload('0196643e', __exports__)
  }
  
  module.hot.accept("./Plane.vue?vue&type=template&id=0196643e", () => {
    api.rerender('0196643e', render)
  })

}


export default __exports__